import { computed } from 'vue'
import { useCore } from '@/composables/core'
import { getExternalId } from '@/lib/analytics/helpers.js'

export function useAnalyticsCommonParams () {
  const { store } = useCore()

  const routingConfig = computed(() => store.state.routingConfig.config)
  const country = computed(() => store.state.app.country)
  const user = computed(() => store.state.identity?.user)
  const business = computed(() => store.state.business?.business)

  const _getExternalId = (id) => {
    return getExternalId({
      id,
      country: country.value,
      routingConfig: routingConfig.value,
    })
  }

  const userId = computed(() => _getExternalId(user.value?.id))
  const businessId = computed(() => _getExternalId(business.value?.id))

  return {
    businessId,
    country,
    userId,
  }
}
